import React, { ReactNode, useEffect } from 'react';
import { Box } from '@mui/material';
import ActivityLibraryComponent from '../../components/ActivityLibrary/ActivityLibraryBlock/ActivityLibrary';
import SingleFolder from '../../components/ActivityLibrary/ActivityLibraryBlock/SingleFolder';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  ActivityLibraryBlocks,
  clearFolder,
  setActivityLibraryBlock,
} from '../../redux/activityLibrary/activityLibrarySlice';

const activityLibraryBlocks: Record<ActivityLibraryBlocks, ReactNode> = {
  activityLibrary: <ActivityLibraryComponent />,
  singleFolder: <SingleFolder />,
};

export default function ActivityLibrary() {
  const currentBlock = useAppSelector((state) => state.activityLibrary.block);
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(setActivityLibraryBlock());
      dispatch(clearFolder());
    },
    []
  );

  return (
    <Box height="100%" width="100%">
      {activityLibraryBlocks[currentBlock]}
    </Box>
  );
}
